import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  InputNumber,
  Switch,
  Upload,
  message,
  Card,
  Row,
  Col,
  Spin,
  Divider,
  Image,
  Modal,
  Table,
  Space,
} from "antd";
import {
  UploadOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import api from "../../../api";
import TinyEditor from "../../../components/Editor";
import { SEO_CONFIG } from "../../../seo-congig";

const { TextArea } = Input;

function EditProduct() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams(); // Get product ID from URL
  const location = useLocation();
  const searchParams = location.state?.searchParams || {};

  const [loading, setLoading] = useState(false);
  const [fetchingData, setFetchingData] = useState(true);
  const [categories, setCategories] = useState([]);
  const [guarantees, setGuarantees] = useState([]);
  const [countries, setCountries] = useState([]);
  const [brands, setBrands] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [cars, setCars] = useState([]);
  const [carTypes, setCarTypes] = useState({}); // 改变：使用对象存储每个车型对应的类型
  const [editorContent1, setEditorContent1] = useState("");
  const [uploading, setUploading] = useState(false);
  const [imageFiles, setImageFiles] = useState([]);
  const [currentImages, setCurrentImages] = useState([]);
  const [existingBanner, setExistingBanner] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);

  const [brandFields, setBrandFields] = useState([
    {
      id: "",
      price: "",
      offPrice: "",
      seller_id: "",
      guarantee_id: "",
      country_id: "",
      count: "",
      seller_order: "",
    },
  ]);
  const [carFields, setCarFields] = useState([{ car_id: "", car_type_id: "" }]);

  const handleEditorChange1 = (content) => {
    setEditorContent1(content);
  };

  // Add the handleUpdateGallery function to your component
  const handleUpdateGallery = (updatedGallery) => {
    setGallery(updatedGallery);
  };

  // استخراج مسیر برگشت از پارامترهای URL
  const getReturnPath = () => {
    const params = new URLSearchParams(location.search);
    return params.get("returnTo") || "/products";
  };

  const statusOptions = [
    { value: "0", label: "پیش نویس" },
    { value: "1", label: "منتشر شده" },
  ];

  const urlToFile = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const filename = url.split("/").pop();
      return new File([blob], filename, { type: blob.type });
    } catch (error) {
      console.error("Error converting URL to File:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      setFetchingData(true);
      try {
        const [
          categoriesRes,
          brandsRes,
          carsRes,
          sellerRes,
          countryRes,
          guaranteeRes,
          productRes,
          galleryRes,
        ] = await Promise.all([
          api.get(`/panel/category?per_page=all`),
          api.get(`/panel/brand?type=part&per_page=all`),
          api.get(`/panel/car?per_page=all`),
          api.get(`/panel/seller?per_page=all`),
          api.get(`/panel/country?per_page=all`),
          api.get(`/panel/guarantee?per_page=all`),
          api.get(`/panel/product/${id}`),
          api.get(`/panel/gallery?model=App\\Models\\Post&model_id=${id}`),
        ]);

        setCategories(categoriesRes.data.data || []);
        setBrands(brandsRes.data.data || []);
        setCars(carsRes.data.data || []);
        setSellers(sellerRes.data.data || []);
        setCountries(countryRes.data.data || []);
        setGuarantees(guaranteeRes.data.data || []);
        setGallery(galleryRes.data.data || []);

        const carsData = carsRes.data.data || [];
        const carTypesMap = {};

        carsData.forEach((car) => {
          if (car.car_types && car.car_types.length > 0) {
            carTypesMap[car.id] = car.car_types;
          }
        });

        setCarTypes(carTypesMap);

        const product = productRes.data.data;

        form.setFieldsValue({
          title: product.title,
          slug: product.slug,
          count: product.count,
          technical_code: product.technical_code,
          order: product.order,
          status: product.status.toString(),
          categories: product.category?.map((cat) => cat.id),
          countries: product.country?.map((country) => country.id),
          guarantees: product.guarantee?.map((guarantee) => guarantee.id),
          description: product.meta_description,
          seo_title: product.meta,
          seo_description: product.meta_description,
          canonical: product.canonical,
          follow: product.follow === 1,
          index: product.index === 1,
          original: product.original === 1,
          used: product.used === 1,
          returned: product.returned === 1,
          need_shasi: product.need_shasi === 1,
          showcase: product.showcase === 1,
          suggest: product.suggest === 1,
        });

        setEditorContent1(product.body || "");
        setExistingBanner(product.image);

        if (product.brand && product.brand.length > 0) {
          setBrandFields(
            product.brand.map((brand) => ({
              id: brand?.id,
              price: brand?.price,
              offPrice: brand?.offPrice,
              seller_order: brand?.seller_order,
              seller_id: brand?.seller?.id || "",
              guarantee_id: brand?.guarantee?.id || "",
              country_id: brand?.country?.id || "",
              count: brand?.count || "",
            }))
          );
        }

        if (product.cars && product.cars.length > 0) {
          setCarFields(
            product.cars.map((car) => ({
              car_id: car.id,
              car_type_id: car.car_types?.id || "",
            }))
          );
        }
      } catch (error) {
        message.error("دریافت اطلاعات با خطا مواجه شد");
        console.error("خطا در دریافت اطلاعات:", error);
      } finally {
        setFetchingData(false);
      }
    };

    fetchAllData();
  }, [id]);

  const GalleryModal = ({
    visible,
    onCancel,
    onSave,
    gallery,
    onDeleteImage,
    onUpdateImage, // Add this new prop for updating images
  }) => {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editingImageId, setEditingImageId] = useState(null);

    // Reset form when modal closes
    useEffect(() => {
      if (!visible) {
        setEditMode(false);
        setEditingImageId(null);
        form.resetFields();
        setFileList([]);
      }
    }, [visible, form]);

    const handleUpload = async () => {
      try {
        setUploadingImage(true);
        const values = await form.validateFields();

        if (editMode) {
          // Handle edit mode - update existing image
          const response = await api.post(
            `/panel/gallery/${editingImageId}?_method=PUT`,
            {
              alt: values.alt,
              order: values.order,
            }
          );

          // Find and update the image in the gallery list
          const updatedGallery = gallery.map((item) =>
            item.id === editingImageId
              ? { ...item, alt: values.alt, order: values.order }
              : item
          );

          onUpdateImage(updatedGallery);
          message.success("تصویر با موفقیت ویرایش شد");
        } else {
          // Handle add mode - upload new image
          const formData = new FormData();

          if (fileList.length > 0) {
            formData.append("image", fileList[0].originFileObj || fileList[0]);
          }

          formData.append("alt", values.alt);
          formData.append("order", values.order);

          const response = await api.post(
            "/panel/gallery/upload-product-img",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          onSave(response.data);
          message.success("تصویر با موفقیت آپلود شد");
        }

        // Reset form after submission
        form.resetFields();
        setFileList([]);
        setEditMode(false);
        setEditingImageId(null);
      } catch (error) {
        const action = editMode ? "ویرایش" : "آپلود";
        message.error(`${action} تصویر با خطا مواجه شد`);
        console.error(`خطا در ${action} تصویر:`, error);
      } finally {
        setUploadingImage(false);
      }
    };

    const handleEditImage = (image) => {
      setEditMode(true);
      setEditingImageId(image.id);
      form.setFieldsValue({
        alt: image.alt,
        order: image.order || "",
      });
    };

    const handleCancelEdit = () => {
      setEditMode(false);
      setEditingImageId(null);
      form.resetFields();
      setFileList([]);
    };

    const uploadProps = {
      beforeUpload: (file) => {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
          message.error(`${file.name} فایل تصویر نیست`);
          return Upload.LIST_IGNORE;
        }
        setFileList([file]);
        return false;
      },
      onRemove: () => {
        setFileList([]);
      },
      fileList,
    };

    const columns = [
      {
        title: "نام فایل",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Alt",
        dataIndex: "alt",
        key: "alt",
      },
      {
        title: "Order",
        dataIndex: "order",
        key: "order",
        render: (order) => order || "-",
      },
      {
        title: "تصویر",
        dataIndex: "url",
        key: "url",
        render: (url) => <img src={url} alt="تصویر" width={50} />,
      },
      {
        title: "عملیات",
        key: "actions",
        render: (_, record) => (
          <>
            <Space>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => handleEditImage(record)}
                style={{ marginRight: 8 }}
              >
                ویرایش
              </Button>
              <Button
                danger
                icon={<DeleteOutlined />}
                onClick={() => onDeleteImage(record.id)}
              >
                حذف
              </Button>
            </Space>
          </>
        ),
      },
    ];

    return (
      <Modal
        visible={visible}
        onCancel={onCancel}
        title={editMode ? "ویرایش تصویر" : "مدیریت گالری تصاویر"}
        footer={[
          <Button key="back" onClick={editMode ? handleCancelEdit : onCancel}>
            {editMode ? "انصراف" : "بستن"}
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={uploadingImage}
            onClick={handleUpload}
          >
            {editMode ? "ویرایش" : "آپلود"}
          </Button>,
        ]}
        width={800}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="alt"
            label="Alt"
            rules={[{ required: true, message: "لطفاً alt را وارد کنید" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="order"
            label="Order"
            rules={[{ required: true, message: "لطفاً order را وارد کنید" }]}
          >
            <Input type="number" />
          </Form.Item>

          {!editMode && (
            <Form.Item label="تصویر">
              <Upload {...uploadProps}>
                <Button icon={<UploadOutlined />}>انتخاب تصویر</Button>
              </Upload>
            </Form.Item>
          )}
        </Form>

        <Divider />

        <Table
          columns={columns}
          dataSource={gallery}
          rowKey="id"
          pagination={false}
          scroll={{ y: 300, x: 1000 }}
        />
      </Modal>
    );
  };

  const handleDeleteImage = async (id) => {
    try {
      await api.delete(`/panel/gallery/${id}`);
      const updatedGallery = gallery.filter((image) => image.id !== id);
      setGallery(updatedGallery);
      message.success("تصویر با موفقیت حذف شد");
    } catch (error) {
      message.error("حذف تصویر با خطا مواجه شد");
      console.error("خطا در حذف تصویر:", error);
    }
  };

  const uploadProps = {
    beforeUpload: (file) => {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error(`${file.name} is not an image file`);
        return Upload.LIST_IGNORE;
      }
      setImageFiles((prev) => [...prev, file]);
      return false;
    },
    multiple: true,
    listType: "picture",
    accept: "image/*",
    showUploadList: false,
  };

  const addBrandField = () => {
    setBrandFields([
      ...brandFields,
      { id: "", price: "", offPrice: "", count: "", seller_order: "" },
    ]);
  };

  const addCarField = () => {
    setCarFields([...carFields, { car_id: "", car_type_id: "" }]);
  };

  const removeCarField = (index) => {
    const newCarFields = [...carFields];
    newCarFields.splice(index, 1);
    setCarFields(newCarFields);
  };

  const handleCarFieldChange = (index, field, value) => {
    const newCarFields = [...carFields];
    newCarFields[index][field] = value;

    if (field === "car_id") {
      newCarFields[index].car_type_id = "";
    }

    setCarFields(newCarFields);
  };

  const removeBrandField = (index) => {
    const newBrandFields = [...brandFields];
    newBrandFields.splice(index, 1);
    setBrandFields(newBrandFields);
  };

  const handleBrandFieldChange = (index, field, value) => {
    const newBrandFields = [...brandFields];
    newBrandFields[index][field] = value;
    setBrandFields(newBrandFields);
  };

  const onFinish = async (values) => {
    if (
      !brandFields ||
      brandFields.length === 0 ||
      !brandFields.some((field) => field.id)
    ) {
      message.error("حداقل یک برند باید انتخاب شود");
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();

      const appendIfExists = (key, value) => {
        if (value !== undefined && value !== null && value !== "") {
          formData.append(key, value);
        }
      };

      const basicFields = [
        "title",
        "summery",
        "count",
        "technical_code",
        "order",
        "slug",
        "description",
        "weight",
        "vipCount",
      ];

      basicFields.forEach((field) => {
        appendIfExists(field, values[field]);
      });

      appendIfExists("status", values.status || "0");

      if (Array.isArray(values.categories) && values.categories.length > 0) {
        values.categories.forEach((categoryId) => {
          appendIfExists("categories[]", categoryId);
        });
      }

      if (Array.isArray(brandFields) && brandFields.length > 0) {
        brandFields.forEach((field, index) => {
          appendIfExists(`brands[${index}][id]`, field.id);
          appendIfExists(`brands[${index}][price]`, field.price);
          appendIfExists(`brands[${index}][offPrice]`, field.offPrice);
          appendIfExists(`brands[${index}][seller_order]`, field.seller_order);
          appendIfExists(`brands[${index}][seller_id]`, field.seller_id || "");
          appendIfExists(`brands[${index}][count]`, field.count || "");
          appendIfExists(
            `brands[${index}][guarantee_id]`,
            field.guarantee_id || ""
          );
          appendIfExists(
            `brands[${index}][country_id]`,
            field.country_id || ""
          );
        });
      }

      if (Array.isArray(gallery) && gallery.length > 0) {
        gallery.forEach((image) => {
          appendIfExists("gallery_ids[]", image.id);
        });
      }

      if (Array.isArray(carFields) && carFields.length > 0) {
        carFields.forEach((field, index) => {
          if (field?.car_id || field?.car_type_id) {
            appendIfExists(`cars[${index}][car_id]`, field.car_id);
            appendIfExists(`cars[${index}][car_type_id]`, field.car_type_id);
          }
        });
      }

      // Append editor content
      appendIfExists("body", editorContent1 || "");

      // Process SEO fields with null safety
      appendIfExists("seo_title", values.seo_title);
      appendIfExists("seo_description", values.seo_description);
      appendIfExists("canonical", values.canonical);

      // Process boolean flags with null safety
      formData.append("follow", values.follow ? "1" : "0");
      formData.append("index", values.index ? "1" : "0");
      formData.append("returned", values.returned ? "1" : "0");
      formData.append("original", values.original ? "1" : "0");
      formData.append("used", values.used ? "1" : "0");
      formData.append("need_shasi", values.need_shasi ? "1" : "0");
      formData.append("showcase", values.showcase ? "1" : "0");
      formData.append("suggest", values.suggest ? "1" : "0");

      // Verify ID before making API call
      if (!id) {
        message.error("خطا: شناسه محصول یافت نشد");
        return;
      }

      // Make API call with error handling
      const response = await api.post(
        `/panel/product/${id}?_method=PUT`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Verify successful response
      if (response && response.data) {
        message.success("محصول با موفقیت ویرایش شد");
        // ساخت URL پارامترها برای برگشت به لیست
        const searchParamsString = new URLSearchParams(searchParams).toString();

        // برگشت به صفحه لیست با همان پارامترهای جستجو
        navigate(`/products?${searchParamsString}`);
      } else {
        throw new Error("پاسخ نامعتبر از سمت سرور دریافت شد");
      }
    } catch (error) {
      // Enhanced error handling
      if (error.response) {
        const { data } = error.response;

        if (data.errors) {
          Object.values(data.errors).forEach((errorMessages) => {
            errorMessages.forEach((msg) => message.error(msg));
          });
        } else if (data.message) {
          message.error(data.message);
        } else {
          message.error("خطایی از سمت سرور دریافت شد");
        }
      } else if (error.request) {
        message.error(
          "پاسخی از سرور دریافت نشد، لطفاً اتصال خود را بررسی کنید"
        );
      } else {
        message.error("مشکلی در پردازش درخواست پیش آمد");
      }

      console.error("خطا در ویرایش محصول:", error);
    } finally {
      setLoading(false);
    }
  };

  if (fetchingData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin size="large" tip="در حال بارگذاری..." />
      </div>
    );
  }

  return (
    <div>
      <Card title="ویرایش محصول" className="mb-4">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={() => {
            message.error("لطفاً فیلدهای ضروری را پر کنید.");
          }}
          initialValues={{ active: true }}
          scrollToFirstError
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                name="title"
                label="عنوان"
                rules={[
                  { required: true, message: "لطفاً عنوان را وارد کنید" },
                ]}
              >
                <Input style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                name="slug"
                label="پیوند(لینک این محصول در وبسایت)"
                rules={[
                  { required: true, message: "لطفاً پیوند را وارد کنید" },
                ]}
              >
                <Input style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="technical_code"
                label="کد فنی"
                rules={[
                  { required: true, message: "لطفاً کد فنی را وارد کنید" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="order" label="ترتیب">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="status"
                label=" وضعیت"
                rules={[
                  { required: true, message: "لطفاً  وضعیت را انتخاب کنید." },
                ]}
              >
                <Select placeholder="نوع  وضعیت را انتخاب کنید">
                  {statusOptions.map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="categories"
                label="دسته‌بندی‌ها"
                rules={[
                  {
                    required: true,
                    message: "لطفاً حداقل یک دسته‌بندی را انتخاب کنید",
                  },
                ]}
              >
                <Select
                  style={{ width: "100%" }}
                  mode="multiple"
                  placeholder="دسته‌بندی‌ها را انتخاب کنید"
                  allowClear
                  options={categories.map((category) => ({
                    value: category.id,
                    label: category.name,
                  }))}
                  
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name="description"
            label="توضیحات کوتاه"
            // rules={[{ required: true, message: "لطفاً توضیحات را وارد کنید" }]}
          >
            <TextArea rows={4} />
          </Form.Item>
          <Card>
            <div style={{ marginBottom: 16 }}>
              <strong>تامین کننده‌ها</strong>
            </div>
            {brandFields.map((field, index) => (
              <Row
                gutter={16}
                key={index}
                style={{ marginBottom: 16 }}
                align="middle"
              >
                {/* برند */}
                <Col flex="1 1 200px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    برند
                  </div>
                  <Select
                    placeholder="انتخاب برند تامین کننده"
                    value={field.id}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "id", value)
                    }
                    options={brands.map((brand) => ({
                      value: brand.id,
                      label: brand.name,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }}
                  />
                </Col>

                {/* فروشنده */}
                <Col flex="1 1 200px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    تامین کننده قطعه
                  </div>
                  <Select
                    placeholder="انتخاب تامین کننده"
                    value={field.seller_id}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "seller_id", value)
                    }
                    options={sellers.map((seller) => ({
                      value: seller.id,
                      label: seller.name,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }}
                  />
                </Col>

                {/* گارانتی */}
                <Col flex="1 1 200px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    گارانتی قطعه
                  </div>
                  <Select
                    placeholder="انتخاب گارانتی"
                    value={field.guarantee_id}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "guarantee_id", value)
                    }
                    options={guarantees.map((guarantee) => ({
                      value: guarantee.id,
                      label: guarantee.name,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }}
                  />
                </Col>

                {/* تعداد */}
                <Col flex="1 1 100px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    تعداد
                  </div>
                  <InputNumber
                    placeholder="تعداد"
                    value={field.count}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "count", value)
                    }
                    style={{ width: "100%" }}
                  />
                </Col>

                {/* قیمت */}
                <Col flex="1 1 150px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    قیمت
                  </div>
                  <InputNumber
                    placeholder="قیمت"
                    value={field.price}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "price", value)
                    }
                    style={{ width: "100%" }}
                  />
                </Col>

                {/* قیمت تخفیف */}
                <Col flex="1 1 100px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    قیمت تخفیف
                  </div>
                  <InputNumber
                    placeholder="قیمت تخفیف"
                    value={field.offPrice}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "offPrice", value)
                    }
                    style={{ width: "100%" }}
                  />
                </Col>

                <Col flex="1 1 100px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    اولویت نمایش
                  </div>
                  <InputNumber
                    placeholder="اولویت نمایش"
                    value={field.seller_order}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "seller_id", value)
                    }
                    style={{ width: "100%" }}
                  />
                </Col>

                {/* دکمه حذف */}
                <Col flex="0 0 50px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    حذف
                  </div>
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => removeBrandField(index)}
                    disabled={brandFields.length === 1}
                    style={{ width: "100%" }}
                  />
                </Col>
              </Row>
            ))}
            <Button
              type="dashed"
              onClick={addBrandField}
              icon={<PlusOutlined />}
            >
              افزودن برند قطعه
            </Button>
          </Card>
          <Card className="mt-4">
            <div style={{ marginBottom: 16 }}>
              <strong>خودروها</strong>
            </div>
            {carFields.map((field, index) => (
              <Row
                gutter={16}
                key={index}
                style={{ marginBottom: 16 }}
                align="middle"
              >
                {/* انتخاب خودرو */}
                <Col flex="1 1 300px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    خودرو
                  </div>
                  <Select
                    placeholder="انتخاب خودرو"
                    value={field.car_id}
                    onChange={(value) =>
                      handleCarFieldChange(index, "car_id", value)
                    }
                    options={cars.map((car) => ({
                      value: car.id,
                      label: car.name,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }}
                  />
                </Col>

                {/* انتخاب نوع خودرو */}
                <Col flex="1 1 300px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    نوع خودرو
                  </div>
                  <Select
                    placeholder="انتخاب نوع خودرو"
                    value={field.car_type_id}
                    onChange={(value) =>
                      handleCarFieldChange(index, "car_type_id", value)
                    }
                    options={(carTypes[field.car_id] || []).map((type) => ({
                      value: type.id,
                      label: type.name,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }}
                    disabled={!field.car_id} // غیرفعال کردن در صورت عدم انتخاب خودرو
                  />
                </Col>

                {/* دکمه حذف */}
                <Col flex="0 0 50px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    حذف
                  </div>
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => removeCarField(index)}
                    disabled={carFields.length === 1}
                    style={{ width: "100%" }}
                  />
                </Col>
              </Row>
            ))}
            <Button type="dashed" onClick={addCarField} icon={<PlusOutlined />}>
              افزودن خودرو
            </Button>
          </Card>
          <Form.Item
            label=" محتوا"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (!editorContent1) {
                    return Promise.reject("لطفاً   محتوا را وارد کنید.");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <TinyEditor
              content={editorContent1}
              onEditorChange={handleEditorChange1}
              model={"Product"}
              height={300}
            />
          </Form.Item>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="original" label="اصل" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="used" label="کارکرده" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="returned" label="مرجوعی" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="need_shasi"
                label="نیاز به وارد کردن شاسی"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="showcase"
                label="در ویترین آرشیو"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="suggest"
                label=" پیشنهادی"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="گالری تصاویر">
            <Button type="primary" onClick={() => setModalVisible(true)}>
              مدیریت گالری تصاویر
            </Button>
          </Form.Item>

          <GalleryModal
            visible={modalVisible}
            onCancel={() => setModalVisible(false)}
            onSave={(image) => setGallery([...gallery, image])}
            onDeleteImage={(id) => handleDeleteImage(id)}
            onUpdateImage={handleUpdateGallery}
            gallery={gallery}
          />
          <Divider>بخش سئو</Divider>
          <Form.Item
            name="seo_title"
            label="عنوان سئو"
            help={SEO_CONFIG.title.helpText}
          >
            <Input maxLength={SEO_CONFIG.title.maxLength} showCount />
          </Form.Item>

          <Form.Item
            name="seo_description"
            label="توضیحات سئو"
            help={SEO_CONFIG.description.helpText}
          >
            <TextArea
              rows={4}
              maxLength={SEO_CONFIG.description.maxLength}
              showCount
            />
          </Form.Item>
          <Form.Item name="canonical" label="URL Canonical">
            <Input />
          </Form.Item>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item name="follow" label="Follow" valuePropName="checked">
                <Switch defaultChecked="true" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="index" label="Index" valuePropName="checked">
                <Switch defaultChecked="true" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              ویرایش محصول
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default EditProduct;
